import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUpdateMarkMutation } from '../features/marks/marksApi';

const Table = ({tableHead,data,refetch,tableKeyNames,isSuccess,isError,isLoading,showEdit,showDelete,handleDelete,handleEdit}) => {
    

  const [accMarks,setAccMarks]=useState()

const {pathname}=useLocation();


const[updateMarkFunc,{isSuccess:isupdatemakSucc}]=useUpdateMarkMutation();

useEffect(()=>{
  if(isupdatemakSucc){
    refetch();
  }
},[isupdatemakSucc])

    let content=undefined;

    if(isLoading){
      content=<p>Loading............</p>
    }
    else if(!isLoading && isError){
      content=<p>Something went wrong!</p>
    
    }
    else if(!isLoading && !isError && isSuccess && data?.length==0){
      content=<p>No Videos availabe!</p>
    
    }
    
    else if(!isLoading && !isError && isSuccess  && data?.length > 0){
      content=data.map((table,index)=>(  <tr key={table.id}>
        {
            tableKeyNames?.map((item,ind)=>
               { return (item=='mark' && table.status!=='published' && pathname.includes('assignment-marks'))  ? <></> : <td className="table-td">{table?.[tableKeyNames?.[ind]]?.length > 100 ? table?.[tableKeyNames?.[ind]].slice(0,100) :table?.[tableKeyNames?.[ind]]}{table?.[tableKeyNames?.[ind]]?.length > 100 && '....' }</td>}
            )
       

        }
          
      
     
       
       {pathname.includes('assignment-marks') ? 
       <>
        {table?.status ? table.status!=='published' &&   <td class="table-td input-mark">
                                    <input max="100" onChange={(e)=>setAccMarks(e.target.value)}   />
                                    <button onClick={()=>updateMarkFunc({id:table.id,data:{...table,"mark": accMarks,"status": "published"}})}><svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                        class="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M4.5 12.75l6 6 9-13.5" />
                                    </svg></button>

                                </td> :    <td class="table-td input-mark">
                              
                                    
                                    <button onClick={()=>{}}><svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                        class="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M4.5 12.75l6 6 9-13.5" />
                                    </svg></button>

                                </td> }
       </>
     
                                
                              :<>
                              
                              <td className="table-td flex gap-x-2">
        {showDelete && <button onClick={()=>handleDelete(table?.id)}>
         <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 hover:text-red-500 cursor-pointer transition-all">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
         </button>}
        {showEdit && <button onClick={()=>handleEdit(table?.id)}> <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 hover:text-blue-500 cursor-pointer transition-all">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
          </svg></button>}
        </td>
                              </>
                              }

      </tr>))
    
    }


  return (
    <>
    
    <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
                {tableHead.map(th=>( <th key={th} className="table-th">{th}</th>))}
             
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">
           {content}
           
           
           
          </tbody>
        </table>
      </div>

    </>
  )
}

export default Table